// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021cppcc_keep/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 获取所有区县列表
const getDistrictList = () => {
  return http.get(`${urlPrefix}vote-list`);
};

// 获取区县新闻
interface IGetNewsList {
  classId: string | number;
  category?: string;
  page: number;
}
const getNewsList = ({ classId, category, page }: IGetNewsList) => {
  return http.get(`/v1/news/topicList`, {
    params: {
      classId,
      category,
      page,
    },
  });
};
// 获取区县详情
const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
// 获取轮播头条
const getSwiperList = (classId: string | number) => {
  return http.get('/vote/public/controller.php?enews=news-list-top', {
    params: {
      classId,
    },
  });
};

export { getBaseInfo, getDistrictList, getNewsList, getDetail, getSwiperList };
